export default __webpack_public_path__ + "static/media/logo.e943c22b.svg";